<template>
  <v-container>
    <v-row align="center" justify="space-between" no-gutters class="my-3">
      <TagManagerAdder @update="getData"></TagManagerAdder>
      <v-menu
        ref="menu"
        v-model="menu"
        offset-y
        v-if="$vuetify.breakpoint.xsOnly"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon text v-on="on">
            <v-icon v-if="menu === true">far fa-caret-square-up</v-icon>
            <v-icon v-else>far fa-caret-square-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <TagManagerTagRemover list @update="getData"></TagManagerTagRemover>
          <v-list-item :to="{ name: 'TagManagerViewer' }">
            <v-list-item-icon>
              <v-icon>fa-external-link-alt</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              Exporter
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-row align="center" justify="end" no-gutters v-else>
        <TagManagerTagRemover @update="getData"></TagManagerTagRemover>
        <v-btn class="ml-1" :to="{ name: 'TagManagerViewer' }">
          <v-icon small left>fa-external-link-alt</v-icon>
          Exporter
        </v-btn>
      </v-row>
    </v-row>
    <TagManagerList
      :tags.sync="tags"
      :loading="loading"
      @update="getData"
    ></TagManagerList>
  </v-container>
</template>

<script>
import {
  TagManagerAdder,
  TagManagerList,
  TagManagerTagRemover
} from "../components";
import { mapGetters } from "vuex";
export default {
  name: "TagManagerIndex",
  components: {
    TagManagerAdder,
    TagManagerList,
    TagManagerTagRemover
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  computed: {
    ...mapGetters(["getRecipes", "getProducts", "getTagCategories"])
  },
  data() {
    return {
      loading: false,
      tags: [],
      menu: false
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("slo");
        this.loading = true;
        await Promise.all([
          this.$store.dispatch("loadRecipes"),
          this.$store.dispatch("loadProducts"),
          this.$store.dispatch("loadTagCategories")
        ]);
        let tags = [
          ...new Set([
            ...this.getRecipes
              .filter(x => x.data !== null)
              .map(x => x.data.tags)
              .flat(),
            ...this.getProducts
              .filter(x => x.data !== null)
              .map(x => x.data.tags)
              .flat()
          ])
        ];
        const categoryTags = [];
        this.getTagCategories.forEach(c => categoryTags.push(...c.tags));
        this.tags = tags.filter(x => !categoryTags.includes(x));
      } finally {
        this.loading = false;
        this.$store.dispatch("elo");
      }
    }
  }
};
</script>

<style></style>
